var map = {
	"./armorSettings.js": [
		164,
		164
	],
	"./butterfly2Settings.js": [
		862,
		862
	],
	"./butterflySettings.js": [
		156,
		156
	],
	"./chineseDragonSettings.js": [
		131,
		131
	],
	"./cjSettings.js": [
		560,
		560
	],
	"./daisySettings.js": [
		461,
		461
	],
	"./debugSettings.js": [
		332,
		332
	],
	"./dragonSettings.js": [
		50,
		50
	],
	"./foxSettings.js": [
		454,
		454
	],
	"./frogArmorSettings.js": [
		962,
		962
	],
	"./julesSettings.js": [
		924,
		924
	],
	"./kitsuneSettings.js": [
		122,
		122
	],
	"./liquidSettings.js": [
		977,
		977
	],
	"./manekiSettings.js": [
		166,
		166
	],
	"./masksSettings.js": [
		330,
		330
	],
	"./ninjaSettings.js": [
		867,
		867
	],
	"./pearlSettings.js": [
		419,
		419
	],
	"./raccoonSettings.js": [
		562,
		562
	],
	"./riggedSettings.js": [
		711,
		711
	],
	"./sceneSettings.js": [
		963,
		963
	],
	"./spikedSettings.js": [
		403,
		403
	],
	"./stickersSettings.js": [
		445,
		445
	],
	"./tenguSettings.js": [
		0,
		0
	],
	"./thornSettings.js": [
		838,
		838
	],
	"./tribalSettings.js": [
		69,
		69
	],
	"./ultramanSettings.js": [
		367,
		367
	],
	"./wandSettings.js": [
		183,
		183
	],
	"./wingSettings.js": [
		850,
		850
	],
	"./yoroiSettings.js": [
		21,
		21
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 455;
module.exports = webpackAsyncContext;